import itemReducer from './items';
export * from './items';

export default { authorizedClients: itemReducer };
